package com.downdogapp

actual inline fun <reified T : Enum<T>> emptyEnumSet(): MutableSet<T> = mutableSetOf()

actual fun <T : Enum<T>> mutableSetOf(first: T, vararg rest: T): MutableSet<T> =
  kotlin.collections.mutableSetOf(first, *rest)

actual inline fun <reified T : Enum<T>> mutableSetOfNotNull(first: T?, vararg rest: T?): MutableSet<T> =
  mutableSetOf<T>().also { it.addAll(listOfNotNull(first, *rest)) }

actual inline fun <reified T : Enum<T>> Collection<T>.toMutableSet(): MutableSet<T> =
  mutableSetOf<T>().also { it.addAll(this) }

actual fun <T : Enum<T>> Collection<T>.toSet(): Set<T> = mutableSetOf<T>().also { it.addAll(this) }

actual fun <T : Enum<T>> Array<out T>.toSet(): Set<T> = mutableSetOf<T>().also { it.addAll(this) }

actual fun <T> Collection<T>.toSet(): Set<T> = mutableSetOf<T>().also { it.addAll(this) }

actual fun <T> Array<out T>.toSet(): Set<T> = mutableSetOf<T>().also { it.addAll(this) }

actual inline fun <reified T : Enum<T>, U> emptyEnumMap() = mutableMapOf<T, U>()

actual fun <T : Enum<T>, U> mutableMapOf(first: Pair<T, U>, vararg rest: Pair<T, U>): MutableMap<T, U> =
  kotlin.collections.mutableMapOf(first, *rest)

actual inline fun <reified T : Enum<T>, U> Collection<Pair<T, U>>.toMutableMap(): MutableMap<T, U> =
  mutableMapOf<T, U>().also { it.putAll(this) }

actual fun <T : Enum<T>, U> Collection<Pair<T, U>>.toMap(): Map<T, U> = mutableMapOf<T, U>().also { it.putAll(this) }
